module.exports = __webpack_public_path__ + "img/aboutPage_service_icon22.04258b1d.png";